import { Edit, SimpleForm, ReferenceInput, AutocompleteInput, TextInput, SelectInput, BooleanInput, required } from 'react-admin';
import { Box } from '@mui/material';
import { layout } from '../styles/ds';

const TYPE_CHOICES = [
  { id: 'key_map',   name: 'מיפוי מפתח' },
  { id: 'value_map', name: 'מיפוי ערך' },
  { id: 'match_on',  name: 'השוואה על' },
];

const MatchingRuleEdit = () => (
  <Edit title="עריכת כלל התאמה">
    <SimpleForm>
      <ReferenceInput source="rule_set_id" reference="matching_rule_sets">
        <AutocompleteInput label="סט כללים" optionText="name" fullWidth validate={required('שדה חובה')} />
      </ReferenceInput>

      <SelectInput source="rule_type" label="סוג כלל" choices={TYPE_CHOICES} fullWidth />
      <Box sx={layout.formGrid}>
        <TextInput source="from_key"   label="מפתח מקור"  fullWidth inputProps={{ dir: 'ltr' }} />
        <TextInput source="from_value" label="ערך מקור"   fullWidth inputProps={{ dir: 'ltr' }} />
        <TextInput source="to_key"     label="מפתח יעד"     fullWidth inputProps={{ dir: 'ltr' }} />
        <TextInput source="to_value"   label="ערך יעד"      fullWidth inputProps={{ dir: 'ltr' }} />
      </Box>
      <TextInput source="description" label="תיאור הכלל" fullWidth />
      <BooleanInput source="active" label="כלל פעיל" />
    </SimpleForm>
  </Edit>
);

export default MatchingRuleEdit;
